// eslint-disable-next-line banned-modules
'use strict';

import BaseView from '@/classes/base.view.js';
import template from './item.ejs';

export default BaseView.extend({

	template,

	ul: {
		price: '.b-selection__value-price',
	},

	initialize() {
		this.render();
		this.listenTo(this.model, 'change:price', (model, value) => {
			this.ui.price.text(value);
		});
		this.listenTo(this.model, 'change:value', (model, value) => {
			if (value) {
				this.$el.addClass('active');
			} else {
				this.$el.removeClass('active');
			}
			this.model.get('parent').trigger('change:value');
		});
	},

	render() {
		this.setElement(this.template(this.model.attributes));
	},

});
